module.exports = __webpack_public_path__ + "static/img/WS-3.15d29a4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/workshop/WS-3.jpg
// module id = gR12
// module chunks = 0